import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, CircularProgress, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { getSenderHistory, getMailOrbitErrorKey } from 'src/utils/MailOrbitService';
import useStyles from './useStyles';
import { formatDateTime } from './format';

const PAGE = 5;

/** Aynı göndericinin diğer case'leri (sayfalı; yalnızca meta veri). */
const SenderHistory = ({ conversationId }) => {
  const classes = useStyles();
  const { t } = useTranslation(['mailorbit_workorder', 'mailorbit']);
  const [data, setData] = useState({ items: [], total: 0, hasMore: false });
  const [loading, setLoading] = useState(false);
  const [errorKey, setErrorKey] = useState(null);

  const loadPage = useCallback(
    async offset => {
      setLoading(true);
      setErrorKey(null);
      try {
        const res = await getSenderHistory(conversationId, { offset, limit: PAGE });
        setData(prev => ({
          items: offset === 0 ? res.items || [] : [...prev.items, ...(res.items || [])],
          total: res.total || 0,
          hasMore: !!res.hasMore
        }));
      } catch (e) {
        setErrorKey(getMailOrbitErrorKey(e));
      } finally {
        setLoading(false);
      }
    },
    [conversationId]
  );

  useEffect(() => {
    setData({ items: [], total: 0, hasMore: false });
    loadPage(0);
  }, [loadPage]);

  return (
    <Box className={classes.sideSection}>
      {errorKey && <Alert severity="error">{t(`mailorbit:${errorKey}`)}</Alert>}
      {!loading && !errorKey && data.items.length === 0 && (
        <Typography variant="body2" color="textSecondary">
          {t('mailorbit_workorder:no_sender_history')}
        </Typography>
      )}
      {data.items.map(item => (
        <Box key={item.conversationId} className={classes.historyItem}>
          <Typography variant="body2" component="div">
            {`${item.caseReference} · ${item.isSuppressed ? t('mailorbit_workorder:masked_message') : item.subject}`}
          </Typography>
          <Typography variant="caption" color="textSecondary" component="div">
            {`${item.statusName || '-'} · ${formatDateTime(item.lastActivityAtUtc)}`}
          </Typography>
        </Box>
      ))}
      {loading && <CircularProgress size={18} />}
      {data.hasMore && !loading && (
        <Button size="small" color="primary" onClick={() => loadPage(data.items.length)}>
          {t('mailorbit_workorder:load_more')}
        </Button>
      )}
    </Box>
  );
};

SenderHistory.propTypes = { conversationId: PropTypes.string.isRequired };

export default SenderHistory;
